<div class="input-value-container">
  <input
    class="input-value"
    (input)="textInputUpdated()"
    [(ngModel)]="currentInputValue"
    [placeholder]="placeholder ?? ''"
  >

  <div
    class="icon-container "
    [ngClass]="{'icon-container--blur': !currentInputValue}"
    (click)="reset()"
    tabindex="0"
    (keydown.enter)="reset()"
    (keydown.space)="reset()"
  >
    @if (!currentInputValue) {
      <svg-icon src="assets/icons/magnifying-glass.svg" [svgStyle]="{ 'width.px':22 }"></svg-icon>
    } @else {
      <svg-icon src="assets/icons/cross.svg" [svgStyle]="{ 'width.px':22 }"></svg-icon>
    }
  </div>
</div>